import React from "react";
import PropTypes from "prop-types";
import { useContext } from "react";
import { ProfileContext } from "Common/hooks/context/ProfileContext";
import { Card, Statistic, Progress, Typography, Tooltip, Grid } from "antd";
import {
  TeamOutlined,
  BookOutlined,
  BarChartOutlined,
  CheckCircleOutlined,
  FileDoneOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
const { Text } = Typography;
const { useBreakpoint } = Grid;
const StatsCards = ({ styles, statsCardData }) => {
  const { isProfileComplete } = useContext(ProfileContext);
  const isBlocked = !isProfileComplete;
  const screens = useBreakpoint();
  const statCards = [
    {
      title: "Employees",
      value: statsCardData.learnerCount,
      progress: statsCardData.learnerCount,
      icon: <TeamOutlined />,
      color: "#1890ff",
      paragraph: `+${statsCardData.learnerMonthCount}% from last month`,
    },
    {
      title: "In Progress",
      value: statsCardData.inflightCount,
      progress: statsCardData.inflightCount,
      icon: <BookOutlined />,
      color: "#52c41a",
    },
    {
      title: "Completed",
      value: statsCardData.completed,
      progress: statsCardData.completed,
      icon: <CheckCircleOutlined />,
      color: "#13c2c2",
    },
    {
      title: "Requests",
      value: statsCardData.trainingRequestCount,
      progress: statsCardData.trainingRequestCount,
      icon: <BarChartOutlined />,
      color: "#722ed1",
    },
    {
      title: "Reports",
      value: statsCardData.progressReportCount,
      progress: statsCardData.progressReportCount,
      icon: <FileDoneOutlined />,
      color: "#fa8c16",
      link: "/status-reports",
    },
  ];
  const handleCardClick = (stat) => {
    if (isBlocked) return;
    console.log(`Clicked ${stat.title} card`);
  };
  const CardContent = (stat) => (
    <Card
      hoverable
      style={{
        ...styles.card,
        height: '100%',
        cursor: isBlocked ? 'not-allowed' : 'pointer',
        opacity: isBlocked ? 0.6 : 1,
        borderRadius: 8,
        boxShadow: '0 1px 2px 0 rgba(0,0,0,0.05)'
      }}
      bodyStyle={{
        padding: '16px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
      }}
      onClick={() => handleCardClick(stat)}
    >
      <Statistic
        title={<Text style={{ color: styles.textColor.color, fontSize: screens.xs ? '12px' : '14px' }}>{stat.title}</Text>}
        value={stat.value}
        prefix={stat.icon}
        valueStyle={{
          color: stat.color,
          fontSize: screens.xs ? '20px' : '24px',
          fontWeight: 600
        }}
        style={{ marginBottom: 8 }}
      />
      <Progress
        percent={stat.progress}
        showInfo={false}
        strokeColor={stat.color}
        strokeWidth={screens.xs ? 6 : 8}
      />
      {stat.paragraph && (
        <Text type="secondary" style={{ fontSize: '12px', marginTop: 8 }}>
          {stat.paragraph}
        </Text>
      )}
    </Card>
  );
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
      gap: '16px',
      width: '100%'
    }}>
      {statCards.map((stat, index) => (
        <Tooltip
          key={index}
          title={isBlocked ? "Complete your profile to access this feature" : ""}
        >
          {stat.link ? (
            <Link
              to={isBlocked ? '#' : stat.link}
              style={{ textDecoration: "none" }}
              onClick={(e) => isBlocked && e.preventDefault()}
            >
              {CardContent(stat)}
            </Link>
          ) : (
            CardContent(stat)
          )}
        </Tooltip>
      ))}
    </div>
  );
};
StatsCards.propTypes = {
  styles: PropTypes.shape({
    card: PropTypes.object,
    textColor: PropTypes.object,
    secondaryTextColor: PropTypes.object,
  }).isRequired,
  statsCardData: PropTypes.shape({
    learnerCount: PropTypes.number,
    learnerMonthCount: PropTypes.number,
    inflightCount: PropTypes.number,
    completed: PropTypes.number,
    trainingRequestCount: PropTypes.number,
    progressReportCount: PropTypes.number,
  }).isRequired,
};

export default StatsCards;
